import { render, staticRenderFns } from "./DoKoHtmlDialog.vue?vue&type=template&id=b4cc6a36&scoped=true&"
import script from "./DoKoHtmlDialog.vue?vue&type=script&lang=ts&"
export * from "./DoKoHtmlDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoHtmlDialog.vue?vue&type=style&index=0&id=b4cc6a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cc6a36",
  null
  
)

export default component.exports